import { post } from '..';
import { ensureDefaultRoleReadPermissions } from '../../constants/UserPermissions';

const createRole = (
  name: string,
  description: string,
  permissions: string[],
  roleColor: string,
) => post(
  'users/roles',
  {
    name,
    description,
    permissions: ensureDefaultRoleReadPermissions(permissions),
    color: roleColor,
  },
);

export default createRole;
